<template>
    <div class="innovation-page">
        <div class="banner link">
            <div class="mask">
                <img src="@/assets/images/sustainable/innovation/banner.png" alt="零碳未来banner图片" />
            </div>
            <div class="content">
                <div class="wrap">
                    <img class="logo" src="@/assets/images/sustainable/innovation/logo.png" alt="零碳未来" />
                    <h3>共赴双碳目标</h3>
                    <p class="desc">
                        作为一家肩负社会责任感的企业，顺丰从环境保护和节约资源的目标出发，将科技力量注入自身运营，积极打造可持续发展的供应链服务。同时，顺丰将绿色价值延伸至产业链，携手上下游伙伴及客户，帮助合作伙伴加速低碳转型，实现绿色发展，共建零碳未来。
                    </p>
                </div>
            </div>
        </div>
        <div class="main-content">
            <div class="content-target">
                <h3>联合国可持续发展目标</h3>
                <target-list pageName="innovation" :targetData="targetInfo" />
                <h3>2022年关键数据</h3>
                <ul class="data-list">
                    <li class="data-item">
                        <div class="desc-top">本年度温室气体排放强度</div>
                        <div class="title"><span>47.6</span><sub> t CO2e/百万营收</sub></div>
                        <div class="desc-bottom">较2021年降低2.1%</div>
                    </li>
                    <li class="data-item">
                        <div class="desc-top">单票快件碳足迹</div>
                        <div class="title"><span>824.5</span><sub>g CO2e/件</sub></div>
                        <div class="desc-bottom">较2021年降低4.2%</div>
                    </li>
                    <li class="data-item">
                        <div class="desc-top">绿色包装</div>
                        <div class="title">
                            <sub class="p-relative">减少原纸</sub><span>4.7</span><sub class="p-relative">万吨及塑料</sub><span>15</span
                            ><sub class="p-relative">万吨</sub>
                        </div>
                        <div class="desc-bottom">通过轻量化、减量化等绿色包装技术</div>
                    </li>
                    <li class="data-item">
                        <div class="desc-top">绿色运输</div>
                        <div class="title"><span>26,000</span><sub>辆+</sub></div>
                        <div class="desc-bottom">累计投放新能源车辆</div>
                    </li>
                    <li class="data-item">
                        <div class="desc-top">绿色产业园</div>
                        <div class="title"><span>984.3</span><sub>万千瓦时</sub></div>
                        <div class="desc-bottom">本年度可再生能源发电量</div>
                    </li>
                </ul>
            </div>
            <accordion pageName="innovation" :cardData="transportCardInfo" />
            <accordion pageName="innovation" :cardData="transferCardInfo" />
            <accordion pageName="innovation" :cardData="cultureCardInfo" />
            <accordion pageName="innovation" :cardData="planCardInfo" />
            <accordion pageName="innovation" :cardData="circularCardInfo" />
            <accordion pageName="innovation" :cardData="climateCardInfo" class="climate" />
            <div class="greenInfo">
                <h3>绿色资讯</h3>
                <div class="wrap">
                    <div :style="{ backgroundImage: greenContent && `url(${greenContent.mobileBackground.url})` }" class="greenYearItem">
                        <ul class="header">
                            <li
                                v-for="year in yearList"
                                :key="year"
                                :class="{ active: year === selectYear, hide: !yearList.includes(year) }"
                                @click="handleYear(year)"
                            >
                                <span>{{ year }}</span>
                                <icon v-show="year === selectYear" class="icon" name="foreign-change"></icon>
                            </li>
                        </ul>
                        <div class="scroll-wrap">
                            <div class="content-wrap">
                                <div v-for="j in greenContent && greenContent.greenMonth" :key="j && j.id" class="content">
                                    <div class="left">{{ j.month }}</div>
                                    <div class="right">
                                        <div v-for="k in j.greenItem" :key="k.id">
                                            <h5>{{ k.title }}</h5>
                                            <p>
                                                {{ k.desc }}
                                                <a v-if="k.mobileLink" :href="k.mobileLink">了解详情</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="download">
                <a class="link" href="https://www.sf-express.com/uploads/2022_8a7477b59e.pdf" target="_blank">
                    <img src="@/assets/images/sustainable/download-icon.png" alt="《顺丰控股2022年可持续发展报告》" />
                    <p>下载《顺丰控股2022年度可持续发展报告》</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Accordion from './components/accordion'
import TargetList from './components/targetList'
import ajax from '@/api/ajax'
import { urls } from '@/constant/paths'
export default {
    components: {
        Accordion,
        TargetList
    },
    data() {
        return {
            strapiUrl: urls.STRAPI_IMAGE,
            expandTargetCard: false, // 折叠可持续发展选项面板
            climateCardInfo: {
                title: '应对气候变化',
                content:
                    '顺丰以践行国家双碳战略为导向，将应对气候变化融入公司的管理与经营实践，积极开展气候变化相关风险与机遇的识别，努力提升在气候相关议题的治理表现，致力于成为行业可持续发展引领者。',
                cards: [
                    {
                        smallImg: 'item-6-1.png',
                        expandImg: 'item-6-1-big.png',
                        title: '治理',
                        desc: '气候变化风险同其他各类风险一致，均按照公司整体的风险管理流程进行定期识别与评估。董事会风险管理委员会对气候变化风险已有清晰的认知，并作为最高风险管理机构对包含气候变化风险在内的ESG风险拟定应对策略。',
                        expand: false
                    },
                    {
                        smallImg: 'item-6-2.png',
                        expandImg: 'item-6-2-big.png',
                        title: '策略',
                        desc: '顺丰通过定期问卷调查、团队讨论、专家咨询、情景分析、政策分析和行业标杆对比等方法识别风险。风险控制部门针对各项潜在风险进行深入研究，通过其对风控管理目标实现的影响程度评估公司的风险承受度。',
                        expand: false
                    },
                    {
                        smallImg: 'item-6-3.png',
                        expandImg: 'item-6-3-big.png',
                        title: '风险管理',
                        desc: '顺丰不断健全风险管理机制，完善气候风险识别及应对措施，2022年，公司从实体风险与转型风险两个维度，梳理已经识别出来的气候变化风险，并检视更新应对策略。',
                        expand: false
                    },
                    {
                        smallImg: 'item-6-4.png',
                        expandImg: 'item-6-4-big.png',
                        title: '指标和目标',
                        desc: '顺丰致力于通过量化指标衡量自身在应对气候变化风险与机遇方面的工作成果。公司将在每年度的可持续发展报告中持续披露能源消耗量及密度、温室气体排放量及密度等与气候变化相关的环境指标及目标完成进度，努力实现自身2030年减碳目标，助力国家实现“双碳”目标。',
                        expand: false
                    }
                ]
            },

            transportCardInfo: {
                title: '推进低碳运输',
                content:
                    '为降低运输过程中对环境的影响，提升能源使用效率，顺丰持续推进运输环节的绿色低碳转型。2022年，顺丰通过推进低碳运输，减少温室气体排放量达304,029 tCO2e。',
                cards: [
                    {
                        smallImg: 'item-3-1.png',
                        expandImg: 'item-3-1-big.png',
                        title: '绿色陆运',
                        desc: '顺丰通过自购、租赁等方式不断提升新能源车辆数量，持续扩大绿色车队规模。2022年新增投入运营使用的新能源车辆超过4,900台，覆盖城市内普通及大件收派、短途干支线及接驳运输等场景。截至2022年底，顺丰累计投放新能源车辆超过26,000辆，已覆盖232个城市。',
                        expand: false
                    },
                    {
                        smallImg: 'item-3-2.png',
                        expandImg: 'item-3-2-big.png',
                        title: '绿色航空',
                        desc: '顺丰通过优化机型组成、应用节油技术、线上燃油管理、严防维修污染、升级节油激励、优化地面车队、开展节能宣传等措施，实现低能耗高效率的绿色航空运输；',
                        expand: false
                    }
                ]
            },

            transferCardInfo: {
                title: '打造绿色产业园',
                content: '顺丰致力于打造绿色产业园，通过铺设屋面光伏、优化仓库空间布局等多种方式，提高中转效率与节能效益，降低中转环节对环境的影响。',
                cards: [
                    {
                        smallImg: 'item-4-1.png',
                        expandImg: 'item-4-1-big.png',
                        title: '绿色园区管理',
                        desc: '为提升园区物业管理效率，顺丰搭建了物业系统，包含园区环境绿化、安防消防管理、设施设备维修检测等物业模块。公司通过改造园区智能水电表，建立统一的智能化、可视化水电管理平台，实现园区用电用水数据监管，提高了产业园运营效率。',
                        expand: false
                    },
                    {
                        smallImg: 'item-4-2.png',
                        expandImg: 'item-4-2-big.png',
                        title: '可再生能源计划',
                        desc: '公司不断加强清洁能源的使用，积极布局可再生能源发电计划。截至2022年底，共完成9个产业园区的屋面光伏电站建设，光伏铺设面积9.5万平方米，总体装机容量达到13兆瓦以上，年发电量984.3万千瓦时。',
                        expand: false
                    }
                ]
            },
            cultureCardInfo: {
                title: '倡导绿色办公',
                content:
                    '顺丰倡导绿色办公，鼓励员工践行低碳行动，共同营造绿色环保的办公环境，构建资源能源节约型企业。公司鼓励员工开展线上会议，减少不必要的差旅出行，通过各项节能降耗举措，减少水电浪费，实现节能减排。',
                cards: [
                    {
                        smallImg: 'item-5-1.jpg',
                        expandImg: 'item-5-1-big.jpg',
                        title: '用水管理',
                        desc: '加强运营场地用水设备巡检，及时上报问题并维修设备，避免“跑、冒、滴、漏”等水资源浪费情况的发生。',
                        expand: false
                    },
                    {
                        smallImg: 'item-5-2.jpg',
                        expandImg: 'item-5-2-big.jpg',
                        title: '用电管理',
                        desc: '对公共办公区域照明灯进行周期性闲时断电管控，日间用电鼓励员工优先采用自然光代替照明灯，降低电能消耗。同时，根据季节动态调整空调自动开启功能，通过设置合理的空调温度，保证员工舒适办公的同时减少用电浪费。',
                        expand: false
                    },
                    {
                        smallImg: 'item-5-3.jpg',
                        expandImg: 'item-5-3-big.jpg',
                        title: '装修管理',
                        desc: '顺丰对办公场所的施工加以规范，装修过程中产生的装修垃圾、废水等全部按照绿色施工标准排放或由专业第三方公司回收，将对环境造成的污染降至最低。',
                        expand: false
                    }
                ]
            },
            planCardInfo: {
                title: '践行可持续包装',
                content:
                    '顺丰坚定落实邮政业绿色发展“9917”工程的具体要求，加大包装材料研发的投入，寻求绿色包装材料的技术创新、变革与应用。公司以可持续、智能化为方向，推行包装减量化、再利用、可循环、可降解。2022年，顺丰通过推广绿色包装的使用，减少碳排放约50.6万吨。',
                cards: [
                    {
                        smallImg: 'item-2-1.png',
                        expandImg: 'item-2-1-big.png',
                        title: '减量化包装',
                        desc: '顺丰持续对胶袋、胶纸、贴纸、封条等8大类物料进行减量化、标准化、场景化创新研发，通过轻量化、减量化，可折叠等手段，减少塑料消耗。2022年累计减少原纸使用约4.7万吨，减少塑料使用约15万吨。通过包装减量化措施，2022年共计减少碳排放约15万吨。',
                        expand: false
                    },
                    {
                        smallImg: 'item-2-2.png',
                        expandImg: 'item-2-2-big.png',
                        title: '可循环包装',
                        desc: '顺丰针对不同行业和场景，开发满足全场景、全功能应用的可循环包装容器，投用保密运输箱、航空－ 集装温控箱、易碎品循环中转箱、食品循环保温箱、医药循环围板箱等成熟产品，有效解决了传统包装和容器成本高、破损多、操作效率低、资源浪费等问题。2022年，循环箱循环使用次数超过3,200万次，减少碳排放约1.3万吨。',
                        expand: false
                    },
                    {
                        smallImg: 'item-2-3.jpg',
                        expandImg: 'item-2-3-big.jpg',
                        title: '可降解包装',
                        desc: '顺丰持续开展生物降解包装材料的研发，积极进行生物降解包装的技术储备。公司自主研发的全降解包装袋“丰小袋”已在全国推广应用，生物分解率可达90%以上。截至2022年底，“丰小袋”已在北京、广州等地累计投放超过6,251万个。',
                        expand: false
                    }
                ]
            },
            circularCardInfo: {
                title: '推动循环经济',
                content:
                    '顺丰积极响应国家全面推行循环经济的号召，将提高资源利用效率、减少温室气体排放作为绿色发展方向，与产业链上下游开展合作，共同助力“无废城市”建设。',
                cards: [
                    {
                        smallImg: 'item-7-2.jpg',
                        expandImg: 'item-7-2-big.jpg',
                        title: '绿色产业发展',
                        desc: '顺丰参与绿色再生塑料供应链联合工作组 (GRPG)发起的塑料包装高值化利用研究项目，共同探索塑料绿色低碳循环发展新模式和快递“双易”（易回收、易再生）标准的制定，致力于打造“包装研发+社会运营”的企业协同模式，构建“塑料包装设计－生产－ 消费－ 回收－ 再生－ 高值化应用”体系，最大化降低塑料废弃物对生活环境的影响。',
                        expand: false
                    },
                    {
                        smallImg: 'item-7-1.jpg',
                        expandImg: 'item-7-1-big.jpg',
                        title: '培养公众环保意识',
                        desc: '顺丰致力于提高社会公众的绿色环保意识，不仅在公司内部开展环保活动，同时也积极在社会层面推行环保理念。通过开展丰富多样的环保活动，激发社会公众和合作伙伴的环保意识，实现绿色发展，共建“零碳未来”。',
                        expand: false
                    }
                ]
            },
            targetInfo: [
                /*
                {
                    desc: '顺丰在企业内部倡导珍惜每一滴水，并设立《水电管理办法》等制度。在施工期间，顺丰要求废水排放必须符合国家相关标准。同时顺丰在自身的运营过程中，一直避免大规模水资源使用及水污染业务。',
                    bgImg: 'goal-06.png',
                    active: false,
                    bgColor: 'rgb(38,189,226)'
                },
                */
                {
                    desc: '顺丰在义乌、合肥、香港产业园发展光伏发电项目；采购大量新能源汽车及充电桩设备，组建清洁能源车队。',
                    bgImg: 'goal-07.png',
                    active: false,
                    bgColor: 'rgb(252,195,11)'
                },
                {
                    desc: '​顺丰研发了包含丰多宝（π-box）等一系列循环快递容器，搭建循环运营平台进行数据管理，积极联合相关方打造快递包装循环生态圈，助力“无废城市”的实现。',
                    bgImg: 'goal-11.png',
                    active: false,
                    bgColor: 'rgb(253,157,36)'
                },
                {
                    desc: '顺丰以可持续、智能化为产品发展方向，在物流领域积极促进包装产品绿色化、循环化；搭建了循环运营平台进行数据管理，积极联合相关方打造快递包装循环生态圈，助力“无废城市”的实现。',
                    bgImg: 'goal-12.png',
                    active: false,
                    bgColor: 'rgb(191,139,46)'
                },
                {
                    desc: '顺丰从快递包裹运输的各个环节减少能耗，自购、租赁及外包等多种方式增加新能源车辆数量，向着“绿色营运”和“碳中和”的目标前进。',
                    bgImg: 'goal-13.png',
                    active: false,
                    bgColor: 'rgb(63,126,68)'
                }
            ],
            greenNews: [],
            yearList: [],
            selectYear: 2022
        }
    },
    computed: {
        // 显示的绿色资讯
        greenContent() {
            if (this.greenNews.length > 0) {
                return this.greenNews.find(item => item.year === String(this.selectYear))
            }
            return {
                background: {
                    url: ''
                },
                mobileBackground: {
                    url: ''
                }
            }
        }
    },
    created() {
        ajax.getGreenNews().then(res => {
            if (res.length > 0) {
                this.yearList = res.map(item => Number(item.year)).sort((a, b) => b - a)
                // this.yearList = this.yearList.sort((a, b) => Number(b) - Number(a))
                this.selectYear = this.yearList[0]
                this.greenNews = res
            }
        })
    },
    methods: {
        handleYear(year) {
            if (year === -1) {
                return
            }
            this.selectYear = year
        }
    }
}
</script>

<style lang="scss" scoped>
@import './common.scss';
.innovation-page {
    .p-relative {
        position: relative !important;
    }
    .banner {
        .mask:before {
            opacity: 0;
        }
        h3 {
            font-weight: 500;
        }
        .content {
            .wrap {
                padding-top: 0.5rem;
                .logo {
                    width: 3rem;
                    height: 1.4rem;
                    margin-left: -0.1rem;
                    margin-bottom: 0.1rem;
                }
                .desc {
                    text-align: justify;
                }
            }
        }
    }
    .main-content {
        padding: 1rem 0.72rem;
        background-color: #e8e8e8;
        font-size: 0.3rem;
        line-height: 1.8;
        color: #000000;
        .data-list {
            padding-top: 0.44rem;
            padding-left: 0.44rem;
            .title {
                color: #377136;
            }
            .data-item {
                background-color: #e8e8e8;
                margin-bottom: 0.7rem;
                .desc-top {
                    color: #377136;
                    font-size: 0.2rem;
                }
                .desc-bottom {
                    font-size: 0.2rem;
                }
            }
            .gray {
                color: #909090;
            }
        }
        .card {
            >>> .card-header {
                background: #006835;
                .detail-wrap {
                    position: relative;
                }
            }
            .card-body {
                .mask:before {
                    height: 100%;
                }
                .link {
                    .detail-wrap {
                        padding: 0 0.44rem;
                        & > h4 {
                            text-align: left;
                            line-height: 2rem;
                            font-weight: 500;
                        }
                    }
                    &.link-light {
                        .detail-wrap {
                            padding: 0.44rem;
                            & > h4 {
                                line-height: 0.5rem;
                            }
                        }
                    }
                }
            }
        }
        .greenInfo {
            h3 {
                margin-bottom: 0.2rem;
            }
            .wrap {
                color: #fff;
                .greenYearItem {
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    .header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        border-bottom: 0.04rem solid #00a554;
                        background-color: rgba(0, 0, 0, 0.3);
                        overflow-x: auto;
                        li {
                            text-align: center;
                            font-weight: 600;
                            flex: 1;
                            padding: 0.1rem 0.26rem;
                            position: relative;
                            &.active {
                                background-color: #00a554;
                            }
                            &.hide {
                                opacity: 0;
                            }
                            .icon {
                                width: 0.2rem;
                                height: 0.2rem;
                                position: absolute;
                                bottom: 0;
                                left: 50%;
                                transform: translateX(-50%);
                            }
                        }
                    }
                    .scroll-wrap {
                        height: 4rem;
                        background-color: rgba(0, 0, 0, 0.3);
                        padding: 0.25rem;
                        .content-wrap {
                            height: 100%;
                            overflow-y: auto;
                            .content {
                                display: flex;
                                .left {
                                    width: 1rem;
                                    text-align: right;
                                    font-size: 0.24rem;
                                    line-height: 2;
                                    font-weight: 600;
                                }
                                .right {
                                    margin: 0 0.3rem;
                                    flex: 1;
                                    h5 {
                                        font-size: 0.2rem;
                                        font-weight: 600;
                                        line-height: 2.5;
                                    }
                                    p {
                                        font-size: 0.16rem;
                                        margin-bottom: 0.2rem;
                                        text-align: justify;
                                    }
                                    a {
                                        color: #31e291;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/sustainable/innovation.vue